import React, { useContext } from "react";
import { ParsedToken } from "firebase/auth";
import EduateLogo from "../../../images/TransformLogo.svg";
import AnimatedHamburger from "../../../images/AnimatedHamburger.svg";
import Map from "../../../images/Map.svg";

import Asset from "../../../images/Asset Management.svg";
import User_Rights from "../../../images/User_Rights.svg";
import Settings from "../../../images/Settings.svg";
import Customer from "../../../images/Customer.svg";
import { NavLink } from "react-router-dom";
import { CustomTooltip } from "../../../styles/TooltipStyles";
import { TOOLTIP_COLORS } from "../../../styles/Variables";
import { handleSignOut } from "./Header";
import useUrlParams from "../../../customHooks/useUrlParams";
import { AppContext } from "../../../context/context";
import useLabels from "../../../customHooks/useLabels";
import { empType } from "../../../utils/Enum.types";
import Home from "../../../images/Home.svg";
import VmsImage from "../../../images/ItemIcons/Signal Status.svg";
import OpenTicket from "../../../images/dashboard/Open Tickets.svg";
interface Props {
  claims: ParsedToken;
}
const Sidebar = ({ claims }: Props) => {
  const { customer_id } = useUrlParams();
  const isEduate = claims.EDUATE;
  const isEmployee = claims.EMPLOYEE;
  const { state } = useContext(AppContext);
  const { companyLabel } = useLabels();

  const menus = [
    isEduate && state.empSubType === empType.SYS_ADMIN
      ? {
          label: "Customer",
          image: `${Customer}`,
          url: `/`,
        }
      : null,
    !isEduate && state.empSubType === empType.SYS_ADMIN
      ? {
          label: companyLabel,
          image: `${Home}`,
          url: `/${state.customerId ? state.customerId : customer_id}/company/junctions`,
        }
      : null,
    // !isEduate && state.empSubType === empType.SYS_ADMIN
    // ?
    // : null,
    // !isEduate && state.empSubType === empType.SYS_ADMIN
    //   ? {
    //       label: `${companyLabel} User Rights`,
    //       image: `${User_Rights}`,
    //       url: `/${
    //         state.customerId ? state.customerId : customer_id
    //       }/company/users`,
    //     }
    //   : null,
    isEduate
      ? {
          label: "Configurations",
          image: `${Settings}`,
          url: `/${
            state.customerId ? state.customerId : customer_id
          }/company/emailconfig`,
        }
      : null,
    // !isEduate && state.empSubType === empType.SYS_ADMIN
    //   ? {
    //       label: "Settings",
    //       image: `${Settings}`,
    //       url: `/${state.customerId ? state.customerId : customer_id}/billbook`,
    //     }
    //   : null,

    // state.empSubType !== empType.SYS_ADMIN &&
    // state.empSubType !== empType.VENDOR_MANAGER &&
    // !isEduate
    //   ? {
    //       label: "Tickets",
    //       image: `${OpenTicket}`,
    //       url: `/${state.customerId ? state.customerId : customer_id}/tickets`,
    //     }
    //   : null,
    state.empSubType !== empType.SYS_ADMIN && !isEduate
      ? {
          label: "Home",
          image: `${Home}`,
          url: `/${
            state.customerId ? state.customerId : customer_id
          }/dashboard`,
        }
      : null,
    {
      label: "Maps",
      image: `${Map}`,
      url: `/${state.customerId ? state.customerId : customer_id}/ticketing`,
    },

    // state.empSubType !== empType.SYS_ADMIN &&
    // state.empSubType !== empType.VENDOR_MANAGER &&
    // !isEduate
    //   ? {
    //       label: "VMS Boards",
    //       image: `${VmsImage}`,
    //       url: `/${
    //         state.customerId ? state.customerId : customer_id
    //       }/vmsboards`,
    //     }
    //   : null,

    state.empSubType === empType.PMU
      ? {
          label: "Settings",
          image: `${Settings}`,
          url: `/${state.customerId ? state.customerId : customer_id}/banner`,
        }
      : null,
  ].filter(Boolean);

  return (
    <>
      <input type="checkbox" id="menu" name="" />

      <div className="sidebar g-0">
        <div className="sidebar__menu">
          <ul>
            <li>
              <img className="logo tooltip-hide" src={EduateLogo} alt="/" />
              <span className="sidebar__menu--myeduate">
                <img
                  src={EduateLogo}
                  alt="/"
                  className="logo"
                  onClick={handleSignOut}
                />
                transFORM
              </span>
            </li>
            <li>
              <label htmlFor="menu">
                <img
                  className="hamburger"
                  src={AnimatedHamburger}
                  alt="/"
                  id="toggle"
                />
              </label>
            </li>
            {menus.map((res, index) => {
              if (res)
                return (
                  <li key={index}>
                    <NavLink to={res.url}>
                      <CustomTooltip
                        title={res.label}
                        arrow
                        placement="right"
                        slotProps={{
                          tooltip: {
                            sx: {
                              bgcolor: TOOLTIP_COLORS.VARIABLE,
                              "& .MuiTooltip-arrow": {
                                color: TOOLTIP_COLORS.VARIABLE,
                              },
                            },
                          },
                        }}
                      >
                        <img src={res.image} alt="/" className="tooltip-hide" />
                      </CustomTooltip>

                      <span>
                        <img src={res.image} alt="/" />
                        {res.label}
                      </span>
                    </NavLink>
                  </li>
                );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
